<template>
    <div id="catalog-app">
        <header class="header">
            <div class="circle-bg"></div>
            <div class="circle-bg2"></div>
            <div class="circle-bg4"></div>
            <div class="circle-bg5"></div>
            <div class="header-content">
                <div>
                    <div class="logo">
                        <img
                            :src="
                                companyLogoUrl !== null ? companyLogoUrl : baseUrl().concat('static/img/minilogo2.png')
                            "
                            alt="logo"
                        />
                    </div>
                    <div class="search-container" style="display: block">
                        <img src="static/img/search.png" class="searchIcons" alt="search" v-if="!this.searchQuery" />
                        <img src="static/img/close.png" class="searchIcons" alt="close" v-else @click="clearSearch" />
                        <input
                            v-model="searchQuery"
                            type="search"
                            :placeholder="$t('catalog.searchPH')"
                            @input="searchCatalog"
                        />
                        <div id="result-container" v-if="this.searchResult.length > 0 && searchResultView">
                            <ul class="list-group">
                                <li class="list-group-item" id="result-item" v-for="r in filteredItems">
                                    <div @click="getChildren(r)">
                                        <img
                                            src="static/img/description.png"
                                            alt="article"
                                            v-if="r.type == 'content'"
                                            class="resultIcons"
                                        />
                                        <img src="static/img/list.png" alt="list" v-else class="resultIcons" />
                                        {{ $_.get(r.languageContent[0], "name", "-") }}
                                    </div>
                                </li>
                                <div v-if="this.overFiveResult" @click="overFiveResultClose">
                                    <li class="list-group-item see-all" id="result-item">Tüm sonuçları gör</li>
                                </div>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </header>

        <main :class="{ container: !isContentLastChild, textContainer: isContentLastChild }">
            <div class="page-change" v-if="!isContentLastChild">
                <div id="gridButton" class="inbox-type selected-type" @click="gridView">
                    <md-icon>window</md-icon>
                </div>
                <div id="listButton" class="inbox-type" @click="listView">
                    <md-icon>list</md-icon>
                </div>
            </div>
            <nav v-if="!!navigator.length">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <a href="#" @click="goTop">{{ $t("catalog.allCategory") }}</a>
                    </li>
                    <li v-for="(n, i) in navigator" class="breadcrumb-item">
                        <a href="#" @click="backToParent(i + 1)" v-if="i !== navigator.length - 1">
                            {{ $_.get(n.languageContent[$i18n.locale], "name", "-") || "-" }}
                        </a>
                        <span v-else> {{ $_.get(n.languageContent[$i18n.locale], "name", "-") || "-" }} </span>
                    </li>
                </ol>
            </nav>
            <div id="category-area" class="row" v-if="!seeAll">
                <div class="content-box col-lg-4 my-3" v-for="c in content" v-if="!isContentLastChild">
                    <div class="content" @click="getChildren(c)">
                        <div class="content-title">
                            {{ $_.get(c.languageContent[$i18n.locale], "name", "-") || "-" }}
                        </div>
                        <div class="content-date">
                            {{ $t("catalog.lastUpdate") }}: {{ timeFromNow($_.get(c, "updatedAt", null)) }}
                        </div>
                        <div class="content-views" v-if="c.type === 'content'">
                            {{ $t("catalog.views") }}: {{ $_.get(c, "views", 0) }}
                        </div>
                    </div>
                </div>
                <div v-else id="catalogContent">
                    <p></p>
                    <div class="mt-5">
                        <div class="card-body" v-if="!Array.isArray(content[0].languageContent)">
                            <h1 class="text-title">
                                {{ $_.get(content[0].languageContent[$i18n.locale], "name", "-") }}
                            </h1>
                            <div
                                class="card-text"
                                v-html="$_.get(content[0].languageContent[$i18n.locale], 'content', '-')"
                            ></div>
                        </div>
                        <div class="card-body" v-else>
                            <h1 class="text-title">
                                {{ $_.get(toObject(content[0]).languageContent[$i18n.locale], "name", "-") }}
                            </h1>
                            <div
                                class="card-text"
                                v-html="$_.get(toObject(content[0]).languageContent[$i18n.locale], 'content', '-')"
                            ></div>
                        </div>
                    </div>
                </div>
                <div id="rateArea">
                    <div v-if="isContentLastChild" class="mt-3 catalog-reactions">
                        <div class="card-title">{{ $t("catalog.reactionPrompt") }}</div>
                        <div class="catalog-reactions__row" v-if="!alreadyReacted(content[0]._id)">
                            <button class="catalog-reaction" @click="reactContent('sad')">😞</button>
                            <button class="catalog-reaction" @click="reactContent('neutral')">😐</button>
                            <button class="catalog-reaction" @click="reactContent('happy')">😃</button>
                        </div>
                        <div v-else class="catalog-reactions__thanks">{{ $t("catalog.thanks") }}</div>
                        <md-button
                            v-if="alreadyReacted(content[0]._id) === 'sad'"
                            class="md-raised catalog-reaction-cta"
                            @click="startChat"
                            >{{ $t("catalog.sendMessage") }}</md-button
                        >
                    </div>
                </div>
            </div>
            <div id="category-area" class="row" v-if="seeAll">
                <div class="content-box col-lg-4 my-3" v-for="c in searchResult" v-if="seeAll">
                    <div class="content" @click="getChildren(c)">
                        <div class="content-title">
                            {{ $_.get(c.languageContent[0], "name", "-") || "-" }}
                        </div>
                        <div class="content-date">
                            {{ $t("catalog.lastUpdate") }}: {{ timeFromNow($_.get(c, "updatedAt", null)) }}
                        </div>
                        <div class="content-views" v-if="c.type === 'content'">
                            {{ $t("catalog.views") }}: {{ $_.get(c, "views", 0) }}
                        </div>
                    </div>
                </div>
                <div v-else id="catalogContent">
                    <p></p>
                    <div class="mt-5">
                        <div class="card-body" v-if="!Array.isArray(content[0].languageContent)">
                            <h1 class="text-title">
                                {{ $_.get(content[0].languageContent[$i18n.locale], "name", "-") }}
                            </h1>
                            <div
                                class="card-text"
                                v-html="$_.get(content[0].languageContent[$i18n.locale], 'content', '-')"
                            ></div>
                        </div>
                        <div class="card-body" v-else>
                            <h1 class="text-title">
                                {{ $_.get(toObject(content[0]).languageContent[$i18n.locale], "name", "-") }}
                            </h1>
                            <div
                                class="card-text"
                                v-html="$_.get(toObject(content[0]).languageContent[$i18n.locale], 'content', '-')"
                            ></div>
                        </div>
                    </div>
                </div>
                <div id="rateArea">
                    <div v-if="isContentLastChild" class="mt-3 catalog-reactions">
                        <div class="card-title">{{ $t("catalog.reactionPrompt") }}</div>
                        <div class="catalog-reactions__row" v-if="!alreadyReacted(content[0]._id)">
                            <button class="catalog-reaction" @click="reactContent('sad')">😞</button>
                            <button class="catalog-reaction" @click="reactContent('neutral')">😐</button>
                            <button class="catalog-reaction" @click="reactContent('happy')">😃</button>
                        </div>
                        <div v-else class="catalog-reactions__thanks">{{ $t("catalog.thanks") }}</div>
                        <md-button
                            v-if="alreadyReacted(content[0]._id) === 'sad'"
                            class="md-raised catalog-reaction-cta"
                            @click="startChat"
                            >{{ $t("catalog.sendMessage") }}</md-button
                        >
                    </div>
                </div>
            </div>
        </main>
        <footer class="p-1">Powered ⚡ by <a href="https://supsis.com" target="_blank">Supsis</a></footer>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import { toObject } from "../../utils/languageContent";
import DateUtils from "../../utils/DateUtil";

export default {
    name: "Catalog",
    data() {
        return {
            searchResultView: true,
            navigator: [],
            // makale basina tepki: localStorage'dan hidratlanir, id'ye gore izole (sizinti yok)
            reactions: (() => {
                try {
                    return JSON.parse(localStorage.getItem("hc-reactions") || "{}");
                } catch (e) {
                    return {};
                }
            })(),
            isListView: false,
            companyLogoUrl: null,
            baseUrl: () => {
                if (document.currentScript) {
                    let _documentUrl = document.currentScript.src.split("/");
                    return _documentUrl[0] + "//" + _documentUrl[2] + "/";
                } else {
                    return "/";
                }
            },
            searchQuery: "",
            searchTimeout: null,
            searchResult: [],
            overFiveResult: false,
            seeAll: false,
        };
    },
    computed: {
        ...mapState({
            content: (state) => state.catalog.content,
            site: (state) => state.site.site,
            isContentLastChild: (state) => state.catalog.isContentLastChild,
            settings: (state) => state.setting.settings,
            defaultContentLangIndex: (state) =>
                state.catalog.content[0].languageContent.find((l) => l == this.$i18n.locale),
        }),
        filteredItems: function () {
            return this.searchResult.slice(0, 5);
        },
    },
    methods: {
        ...mapActions({
            getMainCategories: "catalog/getCategories",
            setContent: "catalog/setContent",
            setIsLastChild: "catalog/setIsLastChild",
            getContentChildren: "catalog/getChildren",
            searchCatalogQuery: "catalog/searchCatalog",
            openArticle: "catalog/openArticle",
            viewArticle: "catalog/viewArticle",
            reactArticle: "catalog/reactArticle",
            startChatFromArticle: "catalog/startChatFromArticle",
        }),
        timeFromNow(date) {
            return DateUtils.timeFromNow(date);
        },
        clearSearch() {
            this.searchQuery = "";
        },
        reactContent(reaction) {
            const id = this.content[0]._id;
            this.$set(this.reactions, id, reaction);
            this.reactArticle({ id, reaction, lang: this.$i18n.locale });
            try {
                localStorage.setItem("hc-reactions", JSON.stringify(this.reactions));
            } catch (e) {}
        },
        alreadyReacted(id) {
            return this.reactions[id] || null;
        },
        startChat() {
            this.startChatFromArticle({ id: this.content[0]._id, lang: this.$i18n.locale });
            this.$emit("start-chat");
        },
        getChildren(c) {
            this.navigator.push(_.cloneDeep(c));
            if (c.type === "content") {
                this.openArticle({ item: c, lang: this.$i18n.locale }).then(() =>
                    this.viewArticle({ id: c._id, lang: this.$i18n.locale })
                );
            } else {
                this.getContentChildren(c._id);
                this.setIsLastChild(false);
            }
            this.isRootCatalog = false;
            this.clearSearch();
        },
        goTop() {
            this.navigator = [];
            this.getMainCategories();
        },
        backToParent(i) {
            if (this.navigator[i].parentId) {
                this.getContentChildren(this.navigator[i].parentId);
                this.navigator = this.navigator.slice(0, i);
                this.setIsLastChild(false);
            } else {
                this.getMainCategories();
                this.navigator.pop();
                this.setIsLastChild(true);
            }
        },
        gridView() {
            let listButton = document.getElementById("listButton");
            let gridButton = document.getElementById("gridButton");
            this.isListView = false;
            listButton.classList.remove("selected-type");
            gridButton.classList.add("selected-type");
            this.changeView();
        },
        listView() {
            let listButton = document.getElementById("listButton");
            let gridButton = document.getElementById("gridButton");
            this.isListView = true;
            gridButton.classList.remove("selected-type");
            listButton.classList.add("selected-type");
            this.changeView();
        },
        changeView() {
            let categories = document.getElementById("category-area");
            let contentBoxes = document.querySelectorAll(".content-box");
            let listButton = document.getElementById("listButton");
            let gridButton = document.getElementById("gridButton");
            if (!this.isListView) {
                if (categories.classList.contains("list-group")) {
                    categories.classList.add("row");
                    categories.classList.remove("list-group");
                    contentBoxes.forEach((cont) => {
                        cont.classList.add("col-lg-4", "my-3");
                        cont.classList.remove("list-group-item");
                    });
                }
            } else {
                if (categories.classList.contains("row") && !this.isContentLastChild) {
                    categories.classList.add("list-group");
                    categories.classList.remove("row");
                    contentBoxes.forEach((cont) => {
                        cont.classList.remove("col-lg-4", "my-3");
                        cont.classList.add("list-group-item");
                    });
                }
            }
        },
        searchCatalog(e) {
            if (this.searchTimeout) clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                if (this.searchQuery.trim().length > 0) {
                    this.searchCatalogQuery({
                        query: this.searchQuery,
                        lang: this.$i18n.locale,
                    }).then((res) => {
                        this.searchResult = res.data;
                    });
                }
            }, 500);
        },
        toObject(obj) {
            return toObject(obj);
        },
        overFiveResultClose() {
            this.seeAll = true;
            this.searchResultView = false;
        },
    },
    mounted() {
        document.body.style.overflow = "auto";
        if (this.settings.organizationLogo) {
            const asset = this.settings.organizationLogo;
            this.companyLogoUrl = asset.v2Format && asset.cdnUrl
            ? asset.cdnUrl
            :`https://static.supsis.live/${asset.path}${asset.id}.${asset.ext}`;
        }
        const input = document.querySelector("input");
        /* document.addEventListener("click", (event) => {
            if (!input.contains(event.target)) {
                this.clearSearch();
            }
        });*/
    },
    beforeDestroy() {
        document.body.style.overflow = "initial";
    },
    watch: {
        site(val) {
            if (!!val) {
                this.getMainCategories();
            }
        },
        searchQuery(val) {
            if (val == "") {
                this.searchResult = [];
                this.seeAll = false;
                this.searchResultView = true;
            }
        },
        searchResult(val) {
            if (val.length > 5) {
                this.overFiveResult = true;
            } else {
                this.overFiveResult = false;
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,700&display=swap");
body {
    font-family: "Montserrat", Arial, sans-serif;
    margin: 0;
    padding: 0;
    background-color: #f5f8fa;
    color: #333;
}

a {
    text-decoration: none;
    color: #1e90ff;
    transition: color 0.3s ease;
}

a:hover {
    color: #0d639d;
}

.header {
    width: 100vw;
    background-color: #9e8df7;
    padding: 1.5rem 0;
    height: 15rem;
    text-align: center;
    position: relative;
    overflow: visible;
}

.logo {
    position: relative;
    margin-right: 1rem;
    margin-left: 40px;
    width: 5rem;

    img {
        width: 160px;
        height: auto;
    }
}

.search-container {
    position: relative;
    width: 80%;
    left: 50%;
    bottom: 1rem;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1.5rem 1.5rem 1rem 0;
    z-index: 999;
    span {
        position: absolute;
        right: 1rem;
        top: 0.7rem;
    }
    a {
        color: black;
        text-decoration: none;
        &:hover,
        &:active {
            color: black;
        }
    }
    #result-container {
        position: fixed;
        color: #9e8df7;
        width: 97%;
        margin-left: 1.5%;
        .list-group {
            background-color: #f6f8fa;
        }

        #result-item {
            display: flex;
            height: 60px;
            align-items: center;
            border: none;
            transition: all 500ms ease;
            justify-content: center;
            &:hover {
                cursor: pointer;
                background-color: #f0f1f1;
            }
            &.see-all {
                text-decoration: underline;
                display: flex;
                justify-content: center !important;
            }
            .resultIcons {
                position: absolute;
                width: 25px;
                left: 1rem;
                top: 1rem;
            }
        }
    }
}

input[type="search"] {
    border: none;
    background-color: #f5f8fa;
    color: #333;
    font-size: 1.2em;
    padding: 0.8rem 1rem;
    border-radius: var(--sps-radius-pill);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    width: 100%;
}

.search-btn {
    background-color: #f5f8fa;
    border: none;
    padding: 0.8rem 1.5rem;
    font-size: 1.2em;
    cursor: pointer;
    border-radius: var(--sps-radius-pill);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.circle-bg {
    position: absolute;
    top: 50%;
    left: 80%;
    opacity: 0.5;
    transform: translate(-50%, -50%);
    background-color: #f5f8fa;
    width: 220px;
    height: 220px;
    border-radius: 50%;
}
.circle-bg2 {
    position: absolute;
    top: 0%;
    left: 90%;
    opacity: 0.8;
    transform: translate(-50%, -50%);
    background-color: #f5f8fa;
    width: 420px;
    height: 420px;
    border-radius: 50%;
}
.circle-bg4 {
    position: absolute;
    top: 60%;
    left: 10%;
    opacity: 0.5;
    transform: translate(-50%, -50%);
    background-color: #f5f8fa;
    width: 220px;
    height: 220px;
    border-radius: 50%;
}
.circle-bg5 {
    position: absolute;
    top: -10%;
    left: 40%;
    opacity: 0.5;
    transform: translate(-50%, -50%);
    background-color: #f5f8fa;
    width: 320px;
    height: 220px;
    border-radius: 50%;
}
.container {
    padding: 2rem;
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    position: relative;
}

.content {
    height: 180px;
    border-radius: var(--sps-radius-md);
    background-color: #f5f8fa;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem;
    height: auto;
    min-height: 12rem;
    margin-top: 1rem;
}

.content:hover {
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
    transition: all 0.5s ease;
    background: white;
}

.content-title {
    font-size: 20px;
    color: #9e8df7;
    text-align: center;
}

.content-date,
.content-views {
    font-size: 14px;
    color: #777;
    margin-top: 0.5rem;
}

.card {
    border-radius: var(--sps-radius-md);
    background-color: #fff;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    padding: 2rem;
    margin-top: 2rem;
    transform: translateY(20px);
    opacity: 0;
    transition: transform 0.5s ease, opacity 0.3s ease;
}

.card.show {
    transform: translateY(0);
    opacity: 1;
}

.card-title {
    font-size: 24px;
    margin-bottom: 1rem;
    color: #eac55d;
}

.card-text {
    font-size: 16px;
    color: #333;
}

.md-button {
    margin: 0.5rem;
    padding: 0.5rem 1rem;
    font-size: 16px;
    border: none;
    border-radius: var(--sps-radius-xs);
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.md-button.md-raised {
    color: #fff;
    background-color: #1e90ff;
    box-shadow: 0 2px 4px rgba(30, 144, 255, 0.2);
}

.md-button:hover {
    background-color: #0d639d;
}

footer {
    width: 100%;
    background-color: #9e8df7;
    color: #f5f8fa;
    font-size: 12px;
    text-align: center;
    padding: 1rem 0;
    position: fixed;
    bottom: 0;
    z-index: 99;
}

footer a {
    color: #9e8df7;
    opacity: 0.8;
    transition: opacity 0.3s ease;
}
footer a:hover {
    opacity: 1;
}
.textContainer {
    margin: 0;
    background: #fafafa;
}
#catalogContent {
    background: white;
    width: 75%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    .text-title {
        color: black !important;
    }
    .card-body {
        padding-top: 0;
    }
}
.searchIcons {
    color: red;
    width: 25px;
    position: absolute;
    right: 1rem;
    top: 0.6rem;
}
nav {
    width: 75% !important;
    margin: auto;
    border-bottom: 1px solid rgba(128, 128, 128, 0.1);
    ol {
        background: transparent;
        margin: 0;
    }
    .breadcrumb-item + .breadcrumb-item::before {
        content: ">";
    }
}
#rateArea {
    width: 75%;
    margin: auto;
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    background: white;
}
.catalog-reactions {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.catalog-reactions__row {
    display: flex;
    gap: 12px;
    justify-content: center;
}
.catalog-reactions__thanks {
    font-size: 14px;
    color: #777;
    margin-top: 6px;
}
.catalog-reaction {
    font-size: 28px;
    background: transparent;
    border: 0;
    cursor: pointer;
    transition: transform 0.1s;
}
.catalog-reaction:hover {
    transform: scale(1.2);
}
.page-change {
    display: flex;
    border-radius: var(--sps-radius-sm);
    background-color: white;
    margin: 10px 0 0 30px;
    width: 7rem;
    z-index: 99;
    position: absolute;
    top: -25px;
    left: 40%;

    .inbox-type {
        border-radius: var(--sps-radius-sm);
        padding: 5px;
        cursor: pointer;
        display: flex;
        gap: 5px;
        align-items: center;
        width: 50%;
    }

    .selected-type {
        background-color: #d3d3d3;
        color: black;
        font-weight: 600;
    }
}

.content-box {
    border: none;
}
@media screen and (max-width: 600px) {
    .page-change {
        display: none;
    }
    .logo {
        width: 3rem;
    }
    .search {
        bottom: -10px;
        button {
            margin-top: 5px !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/catalog/Catalog.vue